import slice from './reducer'
import commentsSaga from './saga'

export const {
  fetchCommentsRequest,
  fetchCommentsSuccess,
  fetchCommentsError,

  fetchCommentsSilentRequest,
  fetchCommentsSilentSuccess,
  fetchCommentsSilentError,

  createCommentsRequest,
  createCommentsSuccess,
  createCommentsError,

  editCommentsRequest,
  editCommentsSuccess,
  editCommentsError,

  deleteCommentsRequest,
  deleteCommentsSuccess,
  deleteCommentsError,
} = slice.actions

export default slice.reducer
export { commentsSaga }
